import { DEFAULT_PAGINATION_SIZE } from "@/v1/config/constants";
import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_CONFIGURATION_START,
  GET_CONFIGURATION_SUCCESS,
  GET_ENVIRONMENTS_START,
  GET_ENVIRONMENTS_SUCCESS,
  GET_INTEGRATION_SETUPS_START,
  GET_INTEGRATION_SETUPS_SUCCESS,
  GET_INTEGRATORS_START,
  GET_INTEGRATORS_SUCCESS,
  GET_JURISDICTIONS_START,
  GET_JURISDICTIONS_SUCCESS,
  GET_SITES_START,
  GET_SITES_SUCCESS,
  GET_SOFTWARE_START,
  GET_SOFTWARE_SUCCESS,
} from "./types";

const initialState = baseState => ({
  ...baseState,
  detail: {
    ...baseState.detail,
    jackpotCategories: [],
  },
  environments: {
    loading: false,
    productionEnvironments: [],
    results: [],
  },
  jurisdictions: {
    loading: false,
    results: [],
    configuration: {
      loading: false,
      results: [],
    },
  },
  integrationSetups: {
    loading: false,
    results: {},
  },
  integrators: {
    loading: false,
    results: [],
  },
  software: {
    loading: false,
    results: [],
  },
  configuration: {
    loading: false,
    results: [],
  },
  sites: {
    loading: false,
    results: [],
    page: {
      size: DEFAULT_PAGINATION_SIZE,
      totalElements: 0,
      totalPages: 0,
      number: 0,
    },
  },
});

const store = new BaseStore("casinos", initialState);

const reducer = {
  [GET_ENVIRONMENTS_START]: state => ({
    ...state,
    environments: {
      ...state.environments,
      loading: true,
    },
  }),
  [GET_ENVIRONMENTS_SUCCESS]: (state, payload) => ({
    ...state,
    environments: {
      ...state.environments,
      productionEnvironments: payload.productionEnvironments,
      results: payload.environments,
      loading: false,
    },
  }),
  [GET_JURISDICTIONS_START]: state => ({
    ...state,
    jurisdictions: {
      ...state.jurisdictions,
      loading: true,
    },
  }),
  [GET_JURISDICTIONS_SUCCESS]: (state, payload) => ({
    ...state,
    jurisdictions: {
      ...state.jurisdictions,
      results: payload.jurisdictions,
      loading: false,
    },
  }),
  [GET_INTEGRATION_SETUPS_START]: state => ({
    ...state,
    integrationSetups: {
      ...state.integrationSetups,
      loading: true,
    },
  }),
  [GET_INTEGRATION_SETUPS_SUCCESS]: (state, payload) => ({
    ...state,
    integrationSetups: {
      ...state.integrationSetups,
      results: payload.setupsGroupedByJurisdiction,
      loading: false,
    },
  }),
  [GET_INTEGRATORS_START]: state => ({
    ...state,
    integrators: {
      ...state.integrators,
      loading: true,
    },
  }),
  [GET_INTEGRATORS_SUCCESS]: (state, payload) => ({
    ...state,
    integrators: {
      ...state.integrators,
      results: payload.integrators,
      loading: false,
    },
  }),
  [GET_SOFTWARE_START]: state => ({
    ...state,
    software: {
      ...state.software,
      loading: true,
    },
  }),
  [GET_SOFTWARE_SUCCESS]: (state, payload) => ({
    ...state,
    software: {
      ...state.software,
      results: payload.software,
      loading: false,
    },
  }),
  [GET_CONFIGURATION_START]: state => ({
    ...state,
    configuration: {
      ...state.configuration,
      loading: true,
    },
  }),
  [GET_CONFIGURATION_SUCCESS]: (state, payload) => ({
    ...state,
    configuration: {
      ...state.configuration,
      results: payload.configuration,
      loading: false,
    },
  }),
  [GET_SITES_START]: state => ({
    ...state,
    sites: {
      ...state.sites,
      loading: true,
    },
  }),
  [GET_SITES_SUCCESS]: (state, payload) => ({
    ...state,
    sites: {
      ...state.sites,
      results: payload.sites.results,
      page: payload.sites.page,
      loading: false,
    },
  }),
};

export default store.reducer(reducer);
